import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import "firebase/compat/storage"; // Import compat storage
import { initializeFirestore, persistentLocalCache, persistentMultipleTabManager, getFirestore } from "firebase/firestore";

// REPLACE WITH YOUR FIREBASE CONFIGURATION
const firebaseConfig = {
  apiKey: "AIzaSyBDmyAsjyPawz4pj3IMPvuS6FLUxCzRlew",
  authDomain: "kami-survey.firebaseapp.com",
  projectId: "kami-survey",
  storageBucket: "kami-survey.firebasestorage.app",
  messagingSenderId: "164117692744",
  appId: "1:164117692744:web:e73ac058a53a4867df337d"
};

// Initialize Firebase (Singleton pattern)
const app = !firebase.apps.length ? firebase.initializeApp(firebaseConfig) : firebase.app();

// Initialize Firestore (Modular)
let db;
try {
  db = initializeFirestore(app as any, {
    localCache: persistentLocalCache({
      tabManager: persistentMultipleTabManager()
    })
  });
} catch (e) {
  db = getFirestore(app as any);
}

// Initialize Storage (Compat) - Use compat to align with Auth for reliable uploads
const storage = firebase.storage();

export { db, storage };
export const auth = firebase.auth();

export const getSecondaryApp = () => {
  return firebase.initializeApp(firebaseConfig, "SecondaryApp");
}